import { render, staticRenderFns } from "./DictDataManagerWindow.vue?vue&type=template&id=63903d12&scoped=true&"
import script from "./DictDataManagerWindow.vue?vue&type=script&lang=js&"
export * from "./DictDataManagerWindow.vue?vue&type=script&lang=js&"
import style0 from "./DictDataManagerWindow.vue?vue&type=style&index=0&id=63903d12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63903d12",
  null
  
)

export default component.exports